module.exports = __webpack_public_path__ + "img/logo.a57381c8.svg";